import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./styles/main.scss";

import LayoutRoot from "./pages/Root";
import Home from "./pages/Home";
import Training from "./pages/Training";
import Coaching from "./pages/coaching";
import Writing from "./pages/Writing";
import Seminars from "./pages/Seminars";

const router = createBrowserRouter([
  {
    path: "/",
    element: <LayoutRoot />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "training",
        element: <Training />,
      },
      {
        path: "coaching",
        element: <Coaching />,
      },
      {
        path: "writing",
        element: <Writing />,
      },
      {
        path: "seminars",
        element: <Seminars />,
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
